import Vue from "vue";

const actions = {
    async fetchAdminSisenseDashboards() {
        const req = Vue.http.get("/pando/analytics/sisense/getdashboards");
        const resp = (await req).data;
        if (resp.Success && Array.isArray(resp.Data)) return resp.Data;
        else {
            console.error("getAdminSisenseDashboards: Failed to fetch...");
            console.error(resp);
            throw resp;
        }
    },
    async checkWithSisenseForDashboards() {
        const req = Vue.http.get("/pando/analytics/sisense/refreshdashboards");
        const resp = (await req).data;

        if (resp.Success) return true;
        else {
            console.error("refreshAdminSisenseDashboards: Failed to refresh...");
            console.error(resp);
            throw resp;
        }
    },
    async updateSisenseDashbard(context, data) {
        if (!data.dashboardId) throw new Error("updateSisenseDashboard: Missing dashboardID");
        if (!data.payload) throw new Error("updateSisenseDashboard: Missing payload");

        const req = Vue.http.post(`/pando/analytics/sisense/${data.dashboardId}/updatedashboard`, data.payload);
        const resp = (await req).data;

        if (resp.Success) return true;
        else {
            console.error("updateSisenseDashboard: Failed to update...");
            console.error(resp);
            throw resp;
        }
    },
    getSisenseCurrentUsers() {
        return Vue.http.get("/pando/analytics/sisense/getusers").then((resp) => {
            if (resp && resp.data.Success) {
                return resp.data;
            }
            else {
                throw new Error("Unknown error occured");
            }
        })
    },
    setSisenseDashboardOwner(context, request) {
        return Vue.http.post(`/pando/analytics/sisense/${request.dashboardId}/setowner/${request.userId}`).then((resp) => {
            if (resp && resp.data.Success) {
                return resp.data;
            }
            else {
                throw new Error("Unknown error occured");
            }
        })
    },
    getSisenseSharedWithList(context, dashboardId) {
        return Vue.http
            .get(`/pando/analytics/sisense/${dashboardId}/sharedwith`)
            .then(resp => {
                if (resp && resp.data.Success) {
                    return resp.data;
                } else {
                    throw new Error("Unknown error occured");
                }
            });
    },
    async migrateSisenseUserFavorites(context, data) {
        return await Vue.http.post(`/pando/analytics/sisense/${data.oldDashboardId}/migratefavorites/${data.newDashboardId}`);
    },
    async initiateSisenseBackgroundSync() {
        return await Vue.http.post("/pando/analytics/sisense/initiatebackgroundsync");
    }
}

export default {
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/Sisense.js